import { Component, OnInit } from '@angular/core';
import { BasePagedDataSource } from '../../../../base/table/paged-table-base.datasource';
import { ItemType } from '../../models/item-type';
import { Router } from '@angular/router';
import { ItemTypeService } from '../../services/item-type.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { UserService } from '../../../../services/user.service';
import { Observable } from 'rxjs';
import { ConfirmComponent } from '../../../../dialogs/confirm/confirm.component';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-item-type-list',
  templateUrl: './item-type-list.component.html',
  styleUrls: ['./item-type-list.component.css']
})
export class ItemTypeListComponent implements OnInit {

  dataSource : BasePagedDataSource<ItemType> = new BasePagedDataSource<ItemType>(this.itemTypeService);
  displayedColumns = ['actions','code','name','active'];

  constructor(
    private router: Router,
    private itemTypeService:ItemTypeService,
    private dialog: MatDialog,
    public userService:UserService    
  ) { }

  ngOnInit() {
    this.dataSource.loadData();
  }
  OnEdit(model:ItemType){
    if(this.userService.hasRole('TimeTrackingAdmin')){
      this.router.navigate(["/timeTracking/types/edit",model.id]);
    }    
  }
  private ConrimDelete(id:string):Observable<any>{
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = {
      title:"dialogs.question",
      message:"dialogMessages.deleteRecord"
    };

    const dialogRef = this.dialog.open(ConfirmComponent, dialogConfig);
    return dialogRef.afterClosed().pipe(map(
      ret => {
        return ret;
      }
    )); 
  }
  OnDelete(model:ItemType){
    if(model.id){
      this.ConrimDelete(model.id).subscribe((ret)=> {
        if(ret){
          this.itemTypeService.Delete(model.id).subscribe(()=>{
            this.dataSource.loadData();
          });
        }
      })  
    }
  }
  OnAdd(){
    this.router.navigate(["/timeTracking/types/add"]);
  }  
}
